import { Image, Box } from '@sequencehq/core-components'
import { motion } from 'framer-motion'
import { parse } from 'tldts'
import { getLogoSrc } from 'Customer/utils/logo'
import { Avatar } from '../Avatar/Avatar'
import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

const avatarSizes = {
  md: { size: '20px', borderRadius: '6px' },
  lg: { size: '48px', borderRadius: '9999px' }
}

export const WorkspaceAvatar = ({
  workspaceName,
  size = 'lg'
}: {
  workspaceName: string
  size?: 'md' | 'lg'
}) => {
  const merchantQuery = useQuery(
    dashboard20240730Client.getMerchantForSequenceAccount
  )

  const merchant = merchantQuery.data
  const merchantDomain =
    merchant && parse(merchant.appUrl ?? merchant.email ?? '').domain
  const logoSrc = getLogoSrc({ domain: merchantDomain ?? undefined })

  return (
    <Box
      width={avatarSizes[size].size}
      height={avatarSizes[size].size}
      borderRadius={avatarSizes[size].borderRadius}
    >
      {Boolean(merchant && logoSrc) && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
        >
          <Image
            src={logoSrc}
            width={avatarSizes[size].size}
            height={avatarSizes[size].size}
            alt={`${workspaceName} logo`}
            style={{ borderRadius: avatarSizes[size].borderRadius }}
          />
        </motion.div>
      )}

      {Boolean(merchant && !logoSrc) && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
        >
          <Avatar name={workspaceName} size={size} />
        </motion.div>
      )}
    </Box>
  )
}
